import React from 'react';
import { Link } from 'react-router-dom';

function Services() {
  const services = [
    {
      id: 1,
      title: '🏭 Industrial Automation',
      description:
        'Complete automation solutions for manufacturing and assembly lines. We design robotic systems optimized for your production environment.',
      features: [
        '🔧 Production line integration',
        '⚡ Welding and material handling',
        '🔍 Quality inspection systems',
        '🛠️ Custom tooling design',
      ],
    },
    {
      id: 2,
      title: '🔬 Research Robotics',
      description:
        'Advanced robotic platforms for academic and research institutions. Supporting innovation in robotics science and engineering.',
      features: [
        '🤖 Robot platform development',
        '📡 Sensor integration',
        '💻 Control software',
        '📚 Research support',
      ],
    },
    {
      id: 3,
      title: '⚙️ Custom Development',
      description:
        'Bespoke robotic solutions engineered to your exact specifications. From concept through deployment and beyond.',
      features: [
        '💡 Concept and design',
        '🔨 Prototype development',
        '🔗 System integration',
        '🚀 Field deployment',
      ],
    },
    {
      id: 4,
      title: '🔌 System Integration',
      description:
        'Seamless integration of robotic systems with existing infrastructure. We manage the complete integration process.',
      features: [
        '🖥️ Hardware integration',
        '💾 Software interfacing',
        '✅ Testing and validation',
        '📈 Production optimization',
      ],
    },
    {
      id: 5,
      title: '📖 Technical Training',
      description:
        'Comprehensive training programs for operators and engineers. Ensuring your team can maximize system capabilities.',
      features: [
        '👨‍🏫 Operator training',
        '🎓 Technical workshops',
        '🔧 Maintenance training',
        '🏅 Certification programs',
      ],
    },
    {
      id: 6,
      title: '🛡️ Support & Maintenance',
      description:
        'Ongoing technical support and preventive maintenance. Keeping your systems running at peak efficiency.',
      features: [
        '📞 24/7 technical support',
        '🔄 Preventive maintenance',
        '🔧 Troubleshooting',
        '⬆️ System upgrades',
      ],
    },
  ];

  return (
    <section className="services">
      <div className="container">
        <h1>⚙️ Our Services</h1>
        <p className="services-intro">
          Comprehensive robotics solutions tailored to your operational needs.
        </p>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-header">
                <h3>{service.title}</h3>
              </div>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <h2>🚀 Ready to automate your operations?</h2>
          <p>
            Contact our team to discuss your robotics requirements and discover
            how we can help.
          </p>
          <Link to="/contact" className="btn btn-primary">
            💬 Start Your Project
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Services;